<div class="cv-dropdown cv-dropdown-breadcrumb-component" id="{{dropdownId}}">
	<button class="cv-dropdown__toggle action-toggle" 
		[popper]="popperContent"
		[popperTrigger]="'click'"
		[popperPlacement]="'bottom-start'"
		[popperApplyClass]="'cv-dropdown__options'"
		[popperApplyArrowClass]="'cv-dropdown__options__arrow'"
		[popperPositionFixed]="true"
		[popperModifiers]="{preventOverflow: {boundariesElement: 'viewport'}}"
		[popperAppendTo]="'#'+dropdownId"
		(click)="$event.preventDefault()">
		<div class="cv-dropdown__toggle__label">
			<span class="item-value">{{title}}</span>
			<span class="cv-dropdown__toggle__arrow">&#9662;</span>
		</div>
	</button>
	
	<popper-content #popperContent>
		<div class="cv-dropdown__options__list">
			<div class="cv-dropdown__options__list__item action-select" 
				*ngFor="let item of items; let itemIndex = index;"
				(click)="selectItem(item, itemIndex); popperContent.hide();">
				<span class="item-value">{{item[itemTextKey] ? item[itemTextKey] : item}}</span>
			</div>
		</div>
	</popper-content>
</div>